const LEVELS = ["1", "2", "3"];

export function Title({ level = "2", weight = "3", className = "", style, children }) {
  const lvl = LEVELS.includes(level) ? level : "2";
  return (
    <span
      className={`ui-typo ui-title-${lvl} ui-w${weight} ${className}`}
      style={style}
    >
      {children}
    </span>
  );
}
